// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"default_footerContainer__Aby3m","footerSettings":"default_footerSettings__HCspM"};